require(`./src/assets/fonts/css/fontello.css`)
